import appLogger from 'app/shared/loggers/appLogger';

const DEFAULT_ERROR = 'Something went wrong! Please try again.';

export function isApiResponseError(err) {
    return Boolean(err.response);
}

export function isApiRequestError(err) {
    return Boolean(err.request);
}

function getUsefulReqInfo(req) {
    return {
        url: req.originalUrl,
        ip: req.ip,
        referer: req.get('referer'),
        userAgent: req.get('user-agent'),
        host: req.get('host'),
        traceId: req.id,
    };
}

const errorUtils = {
    formatError: (errorData) => {
        let rawErrorsCopy = null;
        let errorCopy = {};

        if (errorData === undefined || errorData.error === undefined) {
            if (errorData && errorData.errors) {
                rawErrorsCopy = errorData.errors;
            }
            errorCopy = {
                message: DEFAULT_ERROR,
            };
        } else {
            errorCopy = errorData.error;

            // status code
            errorCopy.httpStatus = errorData.httpStatus || '';
        }

        return { errorCopy, rawErrorsCopy };
    },
    logApiRequestError(err, req) {
        return errorUtils.logToSplunk({
            error: err,
            errorStack: err.stack,
            errorMessage: err.message,
            axiosConfig: err.config,
            ...req ? getUsefulReqInfo(req) : {},
        }, err.message);
    },
    logApiResponseError(err, req) {
        return errorUtils.logToSplunk({
            error: err,
            errorStack: err.stack,
            errorMessage: err.message,
            responseStatus: err.response.status,
            responseHeaders: err.response.headers,
            ...req ? getUsefulReqInfo(req) : {},
        }, err.message);
    },
    logToSplunk(data, message) {
        if (__SERVER__) {
            appLogger.error(data, message);
        } else {
            // TODO: send to node api to write log
            appLogger.error(data, message);
        }
    },
    handleError({
        error,
        req,
    }) {
        if (isApiResponseError(error)) {
            errorUtils.logApiResponseError(error, req);
        } else if (isApiRequestError(error)) {
            errorUtils.logApiRequestError(error, req);
        } else {
            errorUtils.logToSplunk(error, 'logging general error');
        }
    },
};


export default errorUtils;
